import React from 'react';
import ReactDOM from 'react-dom';
import PTApp from './App';
import PTDialogueApp from './DialogueApp';
import {Log} from './log.js'
import {Settings} from './settings';
import './index.css';


const log = new Log(Settings.logLevel);
const levelId = parseInt(window.location.pathname.split('/').pop());
const request = new Request('/api/level_records/?level=' + levelId, {
    credentials: "include", 
    headers: {'Content-Type': 'Text/JSON'}
})

fetch(request).then(response => {
    response.json().then(levels => {
        const level = levels.find(l=>l.level.id === levelId);
        log.debug("Level data", level);
        if (level.level.level_type == 'video') {
            const app = React.createFactory(PTApp)(level);
            ReactDOM.render(app, document.getElementById('root'));
        } else if (level.level.level_type == 'dialogue') {
            const app = React.createFactory(PTDialogueApp)(level);
            ReactDOM.render(app, document.getElementById('dialogue-root'));
        } else {
            console.log("Unexpected level type");
        }
    })
})



// WEBPACK FOOTER //
// ./src/index.js